import { useEffect, useRef } from 'react';

const useFocusElement = (condition, ref = null) => {
  const element = useRef(ref);

  const setFocus = () => {
    if (element.current) {
      element.current.focus();
    }
  };

  useEffect(() => {
    if (condition) setFocus();
  }, [condition]);

  return [element];
};

export default useFocusElement;
